import salesforce from "@/plugins/salesforce"
import googleApi from "@/plugins/google"
import intellimize from '@/plugins/intellimize';
import reset from "@/plugins/reset"
import storefront from "@/plugins/storefront";
import axios from "axios";
import { load } from "recaptcha-v3";
import i18n from "@/i18n";
import { defineStore } from 'pinia'
import cloneDeep from 'lodash.clonedeep';
import { useDumpsterCommercialStore } from "./dumpstercommercial";
import { useUserStore } from "./user";
import { useAxiosFormStore } from "./axios";
import { useContactUsStore } from "./contactus";

export const useIndexStore = defineStore('IndexStore', {
  state: () => (
      {
        addressVerified: false,
        // Store tracking
        utmSource: '',
        utmCampaign: '',
        utmMedium: '',
        utmTerm: '',
        utmReferrer: '',
        gclid: '',
        fclid: '',
        fbEventId: '',
        _lastTimestamp: 0,
        promoCode: '',
        // quote
        form: useUserStore().form,
        component: '', // 'quote' || contact
        currentTabComponent: "", // 'ServiceView' ||
        servicefromquote: '',
        google: null,
        serviceFormErrors: false,
        showReferral: false,
        formErrors: [],
        snackbar: false,
        completeAddress: false,
        dialog: false,
        sameAddressView: false,
        recaptchaDialog: false,
        completeAddressMsg: "",
        trackViewSplitter: false,
        errorAxios: false,
        // View for when processing orders
        orderView: '',
        apiName: '',
        button:{
          back: {
            width: '19%'
          },
          continue: {
            width: '80%'
          }
        },
        view: {
          prediction: false,
          hoa: false,
          tenant: false,
          hoaAndTenant: false,
        },
        loading: false,
        loadingWithService:false,
        formValid: true,
        addressFormValid: true,
        apartmentsCondosHoas: false,
        // FOOTER
        isPhoneNumberShowing: false,
        storefrontDistrictCodeOverride: 0,
        servicesofferedResi: "",
        servicesofferedComm: "",
        newStoreApi: false,
        servicesLookupLine: "",
        headerstore: false,
        serviceLobLocked: false,
        resiServicesSizes: "",
        commServicesSizes: "",
        constServicesSizes: "",
        resiServicesFrequency: "",
        commServicesFrequency: "",
        resiServicesShowRecycling: false,
        commServicesShowRecycling: false,
        windowSize: {
          x: 0,
          y: 0,
        },
        commChartOfficeLabel: true,
        apiResultOriginal: {
          data: null,
          storeFrontURL: "",
          districtID: "",
        },
        apiResult: {
          data: null,
          storeFrontURL: "",
          districtID: "",
        },
        storefrontResult: {
          store: null,
          user: null,
        },
        // List text field
        jsonForm:[
          {
            id:0,
            icon: '',
            title: '',
            qty: 0,
            size: {} ,
            frequency: {},
          }
        ],
        servicesType: [
          {
            id: 0,
            name: "ResidentialService",
            text: "serviceView.home",
            leadType:"Residential",
            icon: "residential",
            color: "#175E45",
            checked: false,
          },
          {
            id: 1,
            name: "CommercialService",
            text: "serviceView.business",
            leadType:"Commercial",
            icon: "business",
            color: "#1F528F",
            checked: false,
          },
        ],
        sizes: [
          {size: i18n.t('sizes.9596GallonCart', 'en'), sizeFr: i18n.t('sizes.9596GallonCart', 'fr')},
          {size: i18n.t('sizes.2Yard', 'en'), sizeFr: i18n.t('sizes.2Yard', 'fr')},
          {size: i18n.t('sizes.3Yard', 'en'), sizeFr: i18n.t('sizes.3Yard', 'fr')},
          {size: i18n.t('sizes.4Yard', 'en'), sizeFr: i18n.t('sizes.4Yard', 'fr')},
          {size: i18n.t('sizes.6Yard', 'en'), sizeFr: i18n.t('sizes.6Yard', 'fr')},
          {size: i18n.t('sizes.8Yard', 'en'), sizeFr: i18n.t('sizes.8Yard', 'fr')},
          {size: i18n.t('sizes.10Yard', 'en'), sizeFr: i18n.t('sizes.10Yard', 'fr')},
          ],
        servicesWantedForm:[
          {
            id:0,
            title: i18n.t('servicesWantedForm.solidWaste', 'en'),
            titleFr: i18n.t('servicesWantedForm.solidWaste', 'fr'),
            displayTitle: i18n.t('servicesWantedForm.solidWaste'),
            qty: 0,
            size: {} , //
            frequency: {}, //
            icon: 'solidwaste'
          },
          {
            id:1,
            title: i18n.t('servicesWantedForm.recyclingDumpster', 'en'),
            titleFr: i18n.t('servicesWantedForm.recyclingDumpster', 'fr'),
            displayTitle: i18n.t('servicesWantedForm.recyclingDumpster'),
            qty: 0,
            size: {} , //
            frequency: {}, //
            icon: 'recyclingdumpstericon'
          },
        ],
        residentialWantedForm:[
          {
            id:0,
            title: i18n.t('residentialWantedForm.garbagePickup', 'en'),
            titleFr: i18n.t('residentialWantedForm.garbagePickup', 'fr'),
            displayTitle: i18n.t('residentialWantedForm.garbagePickup'),
            qty: 0,
            size: {} , //
            frequency: {}, //
            icon: 'home-garbage'
          },
          {
            id:1,
            title: i18n.t('residentialWantedForm.recycling', 'en'),
            titleFr: i18n.t('residentialWantedForm.recycling', 'fr'),
            displayTitle: i18n.t('residentialWantedForm.recycling'),
            qty: 0,
            size: {} , //
            frequency: {}, //
            icon: 'home-garbage-recycling',
          },
          {
            id: 2,
            title: i18n.t("residentialWantedForm.organics", "en"),
            titleFr: i18n.t("residentialWantedForm.organics", "fr"),
            displayTitle: i18n.t("residentialWantedForm.organics"),
            qty: 0,
            size: {}, //
            frequency: {}, //
            icon: "OrganicWaste",
          },
        ],
        residentialMhoamWantedForm:[
          {
            id:0,
            title: i18n.t('residentialWantedForm.garbagePickup', 'en'),
            titleFr: i18n.t('residentialWantedForm.garbagePickup', 'fr'),
            displayTitle: i18n.t('residentialWantedForm.garbagePickup'),
            qty: 0,
            size: {} , //
            frequency: {}, //
            icon: 'solidwaste',
            icon2: 'mhoam-home-garbage'
          },
          {
            id:1,
            title: i18n.t('residentialWantedForm.recycling', 'en'),
            titleFr: i18n.t('residentialWantedForm.recycling', 'fr'),
            displayTitle: i18n.t('residentialWantedForm.recycling'),
            qty: 0,
            size: {} , //
            frequency: {}, //
            icon: 'recyclingdumpstericon',
            icon2: 'mhoam-home-garbage-recycling'
          },
          {
            id: 2,
            title: i18n.t("servicesWantedForm.organics", "en"),
            titleFr: i18n.t("servicesWantedForm.organics", "fr"),
            displayTitle: i18n.t("servicesWantedForm.organics"),
            qty: 0,
            size: {}, //
            frequency: {}, //
            icon: "OrganicWaste",
          },
        ],
        commercialWantedForm:[
          {
            id:0,
            title: i18n.t('servicesWantedForm.solidWaste', 'en'),
            titleFr: i18n.t('servicesWantedForm.solidWaste', 'fr'),
            displayTitle: i18n.t('servicesWantedForm.solidWaste'),
            qty: 0,
            size: {} , //
            frequency: {}, //
            icon: 'solidwaste',
          },
          {
            id:1,
            title: i18n.t('servicesWantedForm.recyclingDumpster', 'en'),
            titleFr: i18n.t('servicesWantedForm.recyclingDumpster', 'fr'),
            displayTitle: i18n.t('servicesWantedForm.recyclingDumpster'),
            qty: 0,
            size: {} , //
            frequency: {}, //
            icon: 'recyclingdumpstericon',
          },
          {
            id: 2,
            title: i18n.t("servicesWantedForm.organics", "en"),
            titleFr: i18n.t("servicesWantedForm.organics", "fr"),
            displayTitle: i18n.t("servicesWantedForm.organics"),
            qty: 0,
            size: {}, //
            frequency: {}, //
            icon: "OrganicWaste",
          },
        ],
        commercialMhoamWantedForm:[
          {
            id:0,
            title: i18n.t('residentialWantedForm.garbagePickup', 'en'),
            titleFr: i18n.t('residentialWantedForm.garbagePickup', 'fr'),
            displayTitle: i18n.t('residentialWantedForm.garbagePickup'),
            qty: 0,
            size: {} , //
            frequency: {}, //
            icon: 'solidwaste',
            icon2: 'mhoam-home-garbage'
          },
          {
            id:1,
            title: i18n.t('residentialWantedForm.recycling', 'en'),
            titleFr: i18n.t('residentialWantedForm.recycling', 'fr'),
            displayTitle: i18n.t('residentialWantedForm.recycling'),
            qty: 0,
            size: {} , //
            frequency: {}, //
            icon: 'recyclingdumpstericon',
            icon2: 'mhoam-home-garbage'
          },
          {
            id: 2,
            title: i18n.t("residentialWantedForm.organics", "en"),
            titleFr: i18n.t("residentialWantedForm.organics", "fr"),
            displayTitle: i18n.t("residentialWantedForm.organics"),
            qty: 0,
            size: {}, //
            frequency: {}, //
            icon: "OrganicWaste",
          },
        ],
        sizesResiWasteRecycling: [
            {
            id:0,
            text: i18n.t('iAmNotSure', 'en'),
            textFr: i18n.t('iAmNotSure', 'fr'),
            displayText: i18n.t('iAmNotSure'),
            binSize: "",
            amountGarbages: 0,
            weight:'',
            spec: '',
            // businessType:'',
            // description:'',
            icon:'',
            byDefault: true,
            apiName: null
          },
          {
            id:1,
            text: i18n.t('sizesResiWasteRecycling.standard90', 'en'),
            textFr: i18n.t('sizesResiWasteRecycling.standard90', 'fr'),
            displayText: i18n.t('sizesResiWasteRecycling.standard90'),
            binSize: "90 GALLON",
            amountGarbages: 7,
            weight:'7 bags',
            spec: '',
            // businessType:'Small retails shops & Restaurants',
            // description:'25 - 50 Office Staff',
            icon:'home-garbage',
            apiName: "R90Gallon"
          },
          {
            id:2,
            text: i18n.t('sizesResiWasteRecycling.standard95', 'en'),
            textFr: i18n.t('sizesResiWasteRecycling.standard95', 'fr'),
            displayText: i18n.t('sizesResiWasteRecycling.standard95'),
            binSize: "95 GALLON",
            amountGarbages: 7,
            weight:'7 bags',
            spec: '',
            // businessType:'Small retails shops & Restaurants',
            // description:'25 - 50 Office Staff',
            icon:'home-garbage',
            apiName: "R95Gallon"
          },
          {
            id:3,
            text: i18n.t('sizesResiWasteRecycling.standard', 'en'),
            textFr: i18n.t('sizesResiWasteRecycling.standard', 'fr'),
            displayText: i18n.t('sizesResiWasteRecycling.standard'),
            binSize: "96 GALLON",
            amountGarbages: 7,
            weight:'7 bags',
            spec: '',
            // businessType:'Small retails shops & Restaurants',
            // description:'25 - 50 Office Staff',
            icon:'home-garbage',
            byDefault: true,
            apiName: "R96Gallon"
          },
          {
            id:4,
            text: i18n.t('sizesResiWasteRecycling.compact', 'en'),
            textFr: i18n.t('sizesResiWasteRecycling.compact', 'fr'),
            displayText: i18n.t('sizesResiWasteRecycling.compact'),
            binSize: "18 GALLON",
            amountGarbages: 1,
            weight:'1 bag',
            spec: '',
            // businessType:'Small retails shops & Restaurants',
            // description:'25 - 50 Office Staff',
            icon:'home-garbage',
            byDefault: true,
            apiName: "R18Gallon"
          },
          {
            id:5,
            text: i18n.t('sizesResiWasteRecycling.extraSmall', 'en'),
            textFr: i18n.t('sizesResiWasteRecycling.extraSmall', 'fr'),
            displayText: i18n.t('sizesResiWasteRecycling.extraSmall'),
            binSize: "20 GALLON",
            amountGarbages: 1,
            weight:'1 bag',
            spec: '',
            // businessType:'Small retails shops & Restaurants',
            // description:'25 - 50 Office Staff',
            icon:'home-garbage',
            apiName: "R20Gallon"
          },
          {
            id:6,
            text: i18n.t('sizesResiWasteRecycling.small', 'en'),
            textFr: i18n.t('sizesResiWasteRecycling.small', 'fr'),
            displayText: i18n.t('sizesResiWasteRecycling.small'),
            binSize: "32 GALLON",
            amountGarbages: 2,
            weight:'2 bag',
            spec: '',
            // businessType:'Small retails shops & Restaurants',
            // description:'25 - 50 Office Staff',
            icon:'home-garbage',
            byDefault: true,
            apiName: "R32Gallon"
          },
          {
            id:7,
            text: i18n.t('sizesResiWasteRecycling.small35', 'en'),
            textFr: i18n.t('sizesResiWasteRecycling.small35', 'fr'),
            displayText: i18n.t('sizesResiWasteRecycling.small35'),
            binSize: "35 GALLON",
            amountGarbages: 2,
            weight:'2 bag',
            spec: '',
            // businessType:'Small retails shops & Restaurants',
            // description:'25 - 50 Office Staff',
            icon:'home-garbage',
            apiName: "R35Gallon"
          },
          {
            id:8,
            text: i18n.t('sizesResiWasteRecycling.medium60', 'en'),
            textFr: i18n.t('sizesResiWasteRecycling.medium60', 'fr'),
            displayText: i18n.t('sizesResiWasteRecycling.medium60'),
            binSize: "60 GALLON",
            amountGarbages: 4,
            weight:'4 bag',
            spec: '',
            // businessType:'Small retails shops & Restaurants',
            // description:'25 - 50 Office Staff',
            icon:'home-garbage',
            apiName: "R60Gallon"
          },
          {
            id:9,
            text: i18n.t('sizesResiWasteRecycling.medium', 'en'),
            textFr: i18n.t('sizesResiWasteRecycling.medium', 'fr'),
            displayText: i18n.t('sizesResiWasteRecycling.medium'),
            binSize: "64 GALLON",
            amountGarbages: 4,
            weight:'4 bag',
            spec: '',
            // businessType:'Small retails shops & Restaurants',
            // description:'25 - 50 Office Staff',
            icon:'home-garbage',
            byDefault: true,
            apiName: "R64Gallon"
          },
          {
            id:10,
            text: i18n.t('sizesResiWasteRecycling.medium65', 'en'),
            textFr: i18n.t('sizesResiWasteRecycling.medium65', 'fr'),
            displayText: i18n.t('sizesResiWasteRecycling.medium65'),
            binSize: "65 GALLON",
            amountGarbages: 4,
            weight:'4 bag',
            spec: '',
            // businessType:'Small retails shops & Restaurants',
            // description:'25 - 50 Office Staff',
            icon:'home-garbage',
            apiName: "R65Gallon"
          },
        ],
        sizesWasteRecycling: [
          {
          id:0,
          text: i18n.t('iAmNotSure', 'en'),
          textFr: i18n.t('iAmNotSure', 'fr'),
          displayText: i18n.t('iAmNotSure'),
          binSize: "",
          binSizeFr: "",
          amountGarbages: 0,
          weight:'',
          weightFr:'',
          spec: '',
          // businessType:'',
          // description:'',
          icon:'',
          byDefault: true,
          apiName: null, // Pas de `apiName` pour cet élément
        },
        {
          id:1,
          text: i18n.t('sizesWasteRecycling.60Gallon', 'en'),
          textFr: i18n.t('sizesWasteRecycling.60Gallon', 'fr'),
          displayText: i18n.t('sizesWasteRecycling.60Gallon'),
          binSize: i18n.t('sizes.60Gallon', 'en').toUpperCase(),
          binSizeFr: i18n.t('sizes.60Gallon', 'fr').toUpperCase(),
          amountGarbages: 5,
          weight:'5 ' + i18n.t('bags', 'en'),
          weightFr:'5 ' + i18n.t('bags', 'fr'),
          spec: '',
          // businessType:'Small retails shops & Restaurants',
          // description:'25 - 50 Office Staff',
          icon:'home-garbage',
          apiName: "C60Gallon",
        },
        {
          id:2,
          text: i18n.t('sizesWasteRecycling.65Gallon', 'en'),
          textFr: i18n.t('sizesWasteRecycling.65Gallon', 'fr'),
          displayText: i18n.t('sizesWasteRecycling.65Gallon'),
          binSize: i18n.t('sizes.65Gallon', 'en').toUpperCase(),
          binSizeFr: i18n.t('sizes.65Gallon', 'fr').toUpperCase(),
          amountGarbages: 5,
          weight:'5 ' + i18n.t('bags', 'en'),
          weightFr:'5 ' + i18n.t('bags', 'fr'),
          spec: '',
          // businessType:'Small retails shops & Restaurants',
          // description:'25 - 50 Office Staff',
          icon:'home-garbage',
          apiName: "C65Gallon",
        },
        {
          id:3,
          text: i18n.t('sizesWasteRecycling.90Gallon', 'en'),
          textFr: i18n.t('sizesWasteRecycling.90Gallon', 'fr'),
          displayText: i18n.t('sizesWasteRecycling.90Gallon'),
          binSize: i18n.t('sizes.90Gallon', 'en').toUpperCase(),
          binSizeFr: i18n.t('sizes.90Gallon', 'fr').toUpperCase(),
          amountGarbages: 7,
          weight:'7 ' + i18n.t('bags', 'en'),
          weightFr:'7 ' + i18n.t('bags', 'fr'),
          spec: '',
          // businessType:'Small retails shops & Restaurants',
          // description:'25 - 50 Office Staff',
          icon:'home-garbage',
          apiName: "C90Gallon",
        },
        {
          id:4,
          text: i18n.t('sizesWasteRecycling.96Gallon', 'en'),
          textFr: i18n.t('sizesWasteRecycling.96Gallon', 'fr'),
          displayText: i18n.t('sizesWasteRecycling.96Gallon'),
          binSize: i18n.t('sizes.96Gallon', 'en').toUpperCase(),
          binSizeFr: i18n.t('sizes.96Gallon', 'fr').toUpperCase(),
          amountGarbages: 7,
          weight:'7 ' + i18n.t('bags', 'en'),
          weightFr:'7 ' + i18n.t('bags', 'fr'),
          spec: '',
          // businessType:'Small retails shops & Restaurants',
          // description:'25 - 50 Office Staff',
          icon:'home-garbage',
          byDefault: true,
          apiName: "C96Gallon",
        },
        {
          id:5,
          text: i18n.t('sizesWasteRecycling.300Gallon', 'en'),
          textFr: i18n.t('sizesWasteRecycling.300Gallon', 'fr'),
          displayText: i18n.t('sizesWasteRecycling.300Gallon'),
          binSize: i18n.t('sizes.300Gallon', 'en').toUpperCase(),
          binSizeFr: i18n.t('sizes.300Gallon', 'fr').toUpperCase(),
          amountGarbages: 23,
          weight:'23 ' + i18n.t('bags', 'en'),
          weightFr:'23 ' + i18n.t('bags', 'fr'),
          spec: '',
          // businessType:'Small retails shops & Restaurants',
          // description:'25 - 50 Office Staff',
          icon:'home-garbage',
          apiName: "C300Gallon",
        },
        {
          id:6,
          text: i18n.t('sizesWasteRecycling.1Yard', 'en'),
          textFr: i18n.t('sizesWasteRecycling.1Yard', 'fr'),
          displayText: i18n.t('sizesWasteRecycling.1Yard'),
          binSize: i18n.t('sizes.1Yard', 'en').toUpperCase(),
          binSizeFr: i18n.t('sizes.1Yard', 'fr').toUpperCase(),
          amountGarbages:12,
          weight:'200 ' + i18n.t('lbs', 'en'),
          weightFr:'200 ' + i18n.t('lbs', 'fr'),
          spec: i18n.t('dumpsters.1YardDumpsterSpec', 'en'),
          // businessType:'Small retails shops & Restaurants',
          // description:'25 - 50 Office Staff',
          icon:'commercial-dumpster',
          apiName: "C1Yard",
        },
        {
          id:7,
          text: i18n.t('sizesWasteRecycling.1dot5Yard', 'en'),
          textFr: i18n.t('sizesWasteRecycling.1dot5Yard', 'fr'),
          displayText: i18n.t('sizesWasteRecycling.1dot5Yard'),
          binSize: i18n.t('sizes.1dot5Yard', 'en').toUpperCase(),
          binSizeFr: i18n.t('sizes.1dot5Yard', 'fr').toUpperCase(),
          amountGarbages:18,
          weight:'300 ' + i18n.t('lbs', 'en'),
          weightFr:'300 ' + i18n.t('lbs', 'fr'),
          spec: i18n.t('dumpsters.1dot5YardDumpsterSpec', 'en'),
          // businessType:'Small retails shops & Restaurants',
          // description:'25 - 50 Office Staff',
          icon:'commercial-dumpster',
          apiName: "C1_5Yard",
        },
        {
          id:8,
          text: i18n.t('sizesWasteRecycling.2Yard', 'en'),
          textFr: i18n.t('sizesWasteRecycling.2Yard', 'fr'),
          displayText: i18n.t('sizesWasteRecycling.2Yard'),
          binSize: i18n.t('sizes.2Yard', 'en').toUpperCase(),
          binSizeFr: i18n.t('sizes.2Yard', 'fr').toUpperCase(),
          amountGarbages:24,
          weight:'400 ' + i18n.t('lbs', 'en'),
          weightFr:'400 ' + i18n.t('lbs', 'fr'),
          spec: i18n.t('dumpsters.2YardDumpsterSpec', 'en'),
          // businessType:'Small retails shops & Restaurants',
          // description:'25 - 50 Office Staff',
          icon:'commercial-dumpster',
          byDefault: true,
          apiName: "C2Yard",
        },
        {
          id:9,
          text: i18n.t('sizesWasteRecycling.3Yard', 'en'),
          textFr: i18n.t('sizesWasteRecycling.3Yard', 'fr'),
          displayText: i18n.t('sizesWasteRecycling.3Yard'),
          binSize: i18n.t('sizes.3Yard', 'en').toUpperCase(),
          binSizeFr: i18n.t('sizes.3Yard', 'fr').toUpperCase(),
          amountGarbages:30,
          weight:'600 ' + i18n.t('lbs', 'en'),
          weightFr:'600 ' + i18n.t('lbs', 'fr'),
          spec: i18n.t('dumpsters.2YardDumpsterSpec', 'en'),
          // businessType:'Small retails shops & Restaurants',
          // description:'25 - 50 Office Staff',
          icon:'commercial-dumpster',
          byDefault: true,
          apiName: "C3Yard",
        },
        {
          id:10,
          text: i18n.t('sizesWasteRecycling.4Yard', 'en'),
          textFr: i18n.t('sizesWasteRecycling.4Yard', 'fr'),
          displayText: i18n.t('sizesWasteRecycling.4Yard'),
          binSize: i18n.t('sizes.4Yard', 'en').toUpperCase(),
          binSizeFr: i18n.t('sizes.4Yard', 'fr').toUpperCase(),
          amountGarbages:36,
          weight:'800 ' + i18n.t('lbs', 'en'),
          weightFr:'800 ' + i18n.t('lbs', 'fr'),
          spec: i18n.t('dumpsters.4YardDumpsterSpec', 'en'),
          // businessType:'Small retails shops & Restaurants',
          // description:'50 Office Staff',
          icon:'commercial-dumpster',
          byDefault: true,
          apiName: "C4Yard",
        },
        {
          id:11,
          text: i18n.t('sizesWasteRecycling.6Yard', 'en'),
          textFr: i18n.t('sizesWasteRecycling.6Yard', 'fr'),
          displayText: i18n.t('sizesWasteRecycling.6Yard'),
          binSize: i18n.t('sizes.6Yard', 'en').toUpperCase(),
          binSizeFr: i18n.t('sizes.6Yard', 'fr').toUpperCase(),
          amountGarbages:48,
          weight:'1,200 ' + i18n.t('lbs', 'en'),
          weightFr:'1 200 ' + i18n.t('lbs', 'fr'),
          spec: i18n.t('dumpsters.4YardDumpsterSpec', 'en'),
          // businessType:'Midsize retails shops & Restaurants',
          // description:'100 Office Staff',
          icon:'commercial-dumpster',
          byDefault: true,
          apiName: "C6Yard",
        },
        {
          id:12,
          text: i18n.t('sizesWasteRecycling.8Yard', 'en'),
          textFr: i18n.t('sizesWasteRecycling.8Yard', 'fr'),
          displayText: i18n.t('sizesWasteRecycling.8Yard'),
          binSize: i18n.t('sizes.8Yard', 'en').toUpperCase(),
          binSizeFr: i18n.t('sizes.8Yard', 'fr').toUpperCase(),
          amountGarbages:72,
          weight:'1,800 ' + i18n.t('lbs', 'en'),
          weightFr:'1 800 ' + i18n.t('lbs', 'fr'),
          spec: i18n.t('dumpsters.6YardDumpsterSpec', 'en'),
          // businessType:'Big retails shops & Restaurants',
          // desc:'250 Office Staff',
          icon:'commercial-dumpster',
          byDefault: true,
          apiName: "C8Yard",
        },
      ],
      sizesROWasteRecycling: [
        {
          id:0,
          text: i18n.t('iAmNotSure', 'en'),
          textFr: i18n.t('iAmNotSure', 'fr'),
          displayText: i18n.t('iAmNotSure'),
          binSize: "",
          amountGarbages: 0,
          weight:'',
          spec: '',
          // businessType:'',
					// description:'',
					icon:'',
					byDefault: true,
					apiName: null
				},
				{
					id: 1,
          text: i18n.t('10Yard', 'en'),
					textFr: i18n.t('10Yard', 'fr'),
          displayText: i18n.t('10Yard'),
					binSize: '10 YARD',
					description: i18n.t('heavyLoadsRockDirt', 'en'),
          byDefault: true,
					apiName: "Const10Yard"
				},
				{
					id: 2,
					text: i18n.t('12Yard', 'en'),
					textFr: i18n.t('12Yard', 'fr'),
          displayText: i18n.t('12Yard'),
					binSize: '12 YARD',
					description: i18n.t('heavyLoadsRockDirt', 'en'),
          byDefault: true,
					apiName: "Const12Yard"
				},
				{
					id: 3,
					text: i18n.t('15Yard', 'en'),
					textFr: i18n.t('15Yard', 'fr'),
          displayText: i18n.t('15Yard'),
					binSize: '15 YARD',
          description: i18n.t('homeCleanOutsFitsInMostDriveways', 'en'),
          byDefault: true,
					apiName: "Const15Yard"
				},
				{
					id: 4,
					text: i18n.t('18Yard', 'en'),
					textFr: i18n.t('18Yard', 'fr'),
          displayText: i18n.t('18Yard'),
					binSize: '18 YARD',
					description: i18n.t('remodelingLandscaping', 'en'),
          byDefault: true,
					apiName: "Const18Yard"
				},
				{
					id: 5,
					text: i18n.t('20Yard', 'en'),
					textFr: i18n.t('20Yard', 'fr'),
          displayText: i18n.t('20Yard'),
					binSize: '20 YARD',
					description: i18n.t('remodelingLandscaping', 'en'),
          byDefault: true,
					apiName: "Const20Yard"
				},
				{
					id: 6,
					text: i18n.t('30Yard', 'en'),
					textFr: i18n.t('30Yard', 'fr'),
          displayText: i18n.t('30Yard'),
					binSize: '30 YARD',
					description: i18n.t('remodelingAndConstruction', 'en'),
          byDefault: true,
					apiName: "Const30Yard"
				},
				{
					id: 7,
					text: i18n.t('40Yard', 'en'),
					textFr: i18n.t('40Yard', 'fr'),
          displayText: i18n.t('40Yard'),
					binSize: '40 YARD',
					description: i18n.t('largeAmountOfConstructionDebris', 'en'),
          byDefault: true,
					apiName: "Const40Yard"
				},
      ],
      pickupFrequencies: [
        { id: 0, frequency: i18n.t('frequencyPicker.1xPerWeek', 'en'), frequencyFr: i18n.t('frequencyPicker.1xPerWeek', 'fr'), displayFrequency: i18n.t('frequencyPicker.1xPerWeek'), pickupFrequency:"1XW"},
        { id: 1, frequency: i18n.t('frequencyPicker.2xPerWeek', 'en'), frequencyFr: i18n.t('frequencyPicker.2xPerWeek', 'fr'), displayFrequency: i18n.t('frequencyPicker.2xPerWeek'), pickupFrequency:"2XW"},
        { id: 2, frequency: i18n.t('frequencyPicker.3xPerWeek', 'en'), frequencyFr: i18n.t('frequencyPicker.3xPerWeek', 'fr'), displayFrequency: i18n.t('frequencyPicker.3xPerWeek'), pickupFrequency:"3XW"},
        { id: 3, frequency: i18n.t('frequencyPicker.everyOtherWeek', 'en'), frequencyFr: i18n.t('frequencyPicker.everyOtherWeek', 'fr'), displayFrequency: i18n.t('frequencyPicker.everyOtherWeek'), pickupFrequency:"EOW"},
        { id: 4, frequency: i18n.t('frequencyPicker.monthly', 'en'), frequencyFr: i18n.t('frequencyPicker.monthly', 'fr'), displayFrequency: i18n.t('frequencyPicker.monthly'), pickupFrequency:"1XM"},
        { id: 5, frequency: i18n.t('frequencyPicker.other', 'en'), frequencyFr: i18n.t('frequencyPicker.other', 'fr'), displayFrequency: i18n.t('frequencyPicker.other'), pickupFrequency:"Other"}
      ],
      itemsType: [
        {itemType: i18n.t('itemsType.furniture', 'en'), itemTypeFr: i18n.t('itemsType.furniture', 'fr')},
        {itemType: i18n.t('itemsType.appliance', 'en'), itemTypeFr: i18n.t('itemsType.appliance', 'fr')},
        {itemType: i18n.t('itemsType.mattress', 'en'), itemTypeFr: i18n.t('itemsType.mattress', 'fr')},
        {itemType: i18n.t('itemsType.other', 'en'), itemTypeFr: i18n.t('itemsType.other', 'fr')},
        ],
      businessTypes: [
        { id: 1, name: i18n.t('businessTypes.restaurantsHospitality', 'en'), nameFr: i18n.t('businessTypes.restaurantsHospitality', 'fr'), displayName: i18n.t('businessTypes.restaurantsHospitality') },
        { id: 2, name: i18n.t('businessTypes.healthcareProfessionalServices', 'en'), nameFr: i18n.t('businessTypes.healthcareProfessionalServices', 'fr'), displayName: i18n.t('businessTypes.healthcareProfessionalServices') },
        { id: 3, name: i18n.t('businessTypes.retail', 'en'), nameFr: i18n.t('businessTypes.retail', 'fr'), displayName: i18n.t('businessTypes.retail') },
        { id: 4, name: i18n.t('businessTypes.constructionDemolition', 'en'), nameFr: i18n.t('businessTypes.constructionDemolition', 'fr'), displayName: i18n.t('businessTypes.constructionDemolition') },
        { id: 5, name: i18n.t('businessTypes.transportationWarehousing', 'en'), nameFr: i18n.t('businessTypes.transportationWarehousing', 'fr'), displayName: i18n.t('businessTypes.transportationWarehousing') },
        { id: 6, name: i18n.t('businessTypes.officesBuildingManagement', 'en'), nameFr: i18n.t('businessTypes.officesBuildingManagement', 'fr'), displayName: i18n.t('businessTypes.officesBuildingManagement') },
        { id: 7, name: i18n.t('businessTypes.manufacturingIndustrial', 'en'), nameFr: i18n.t('businessTypes.manufacturingIndustrial', 'fr'), displayName: i18n.t('businessTypes.manufacturingIndustrial') },
        { id: 8, name: i18n.t('businessTypes.personalServices', 'en'), nameFr: i18n.t('businessTypes.personalServices', 'fr'), displayName: i18n.t('businessTypes.personalServices') },
        { id: 9, name: i18n.t('businessTypes.realEstateRentalLeasing', 'en'), nameFr: i18n.t('businessTypes.realEstateRentalLeasing', 'fr'), displayName: i18n.t('businessTypes.realEstateRentalLeasing') },
        { id: 10, name: i18n.t('businessTypes.other', 'en'), nameFr: i18n.t('businessTypes.other', 'fr'), displayName: i18n.t('businessTypes.other') },
      ],
      serviceDetails: [
        {serviceDetail: i18n.t('temporaryDisposalService', 'en'), serviceDetailFr: i18n.t('temporaryDisposalService', 'fr')},
        {serviceDetail: i18n.t('portableToilet', 'en'), serviceDetailFr: i18n.t('portableToilet', 'fr')},
        {serviceDetail: i18n.t('recyclingService', 'en'), serviceDetailFr: i18n.t('recyclingService', 'fr')},
        {serviceDetail: i18n.t('regularWasteDisposoalService', 'en'), serviceDetailFr: i18n.t('regularWasteDisposoalService', 'fr')},
        {serviceDetail: i18n.t('rollOffContainerNeeded', 'en'), serviceDetailFr: i18n.t('rollOffContainerNeeded', 'fr')},
        {serviceDetail: i18n.t('serviceDetailOther', 'en'), serviceDetailFr: i18n.t('serviceDetailOther', 'fr')},
        ],
        summaryList: {},
      }
    ),
  getters: {
    formRules() {
      return {
        acceptConditions: [(v) => !!v || i18n.t("mustAgree")],
        serviceTypeRules: [(v) => !!v || i18n.t("serviceTypeRequired")],
        firstNameRules: [(v) => !!v || i18n.t("firstNameRequired"), (v) => (v && v.length >= 2 && v.length <= 20) || i18n.t("firstNameLength"), (v) =>/^([A-Za-zàâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]{1})+([[A-Za-zàâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]+[,.]?[ ]?|[A-Za-z]+['-àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]]?)+$/.test(v) || i18n.t("firstNameValid"),],
        lastNameRules: [(v) => !!v || i18n.t("lastNameRequired"), (v) => (v && v.length >= 2 && v.length <= 20) || i18n.t("lastNameLength"), (v) => /^([A-Za-zàâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]{1})+([[A-Za-zàâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]+[,.]?[ ]?|[A-Za-z]+['-àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]]?)+$/.test(v) || i18n.t("lastNameValid"),],
        businessNameRules: [(v) => !!v || i18n.t("businessNameRequired"), (v) => ((v.length == 0 || v.length >= 2) && v.length <= 60),],
        addressRules: [(v) => !!v || i18n.t("addressRequired"), (v) => (!!v && v.length >= 2 && v.length <= 300) || i18n.t("addressLength"),],
        phoneRules: [(v) => !!v || i18n.t("phoneRequired"), (v) => (v && v.length >= 2 && v.length <= 100) || i18n.t("phoneLength"), (v) => /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v) || i18n.t("phoneValid"),],
        phoneOptionalRules: [(v) => v == "" || (v && v.length >= 2 && v.length <= 100) || i18n.t("phoneLength"), (v) => v == "" || /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v) || i18n.t("phoneValid"),],
        emailRules: [(v) => !!v || i18n.t("emailRequired"), (v) => /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(v) || i18n.t("emailValid"),],

        // **** New rules added ****
        serviceDetailRules: [(v) => !!v || i18n.t("serviceDetailRequired")],
        shreddingDetailRules: [(v) => !!v || i18n.t("shreddingDetailRequired")],
        descriptionRules: [(v) => (v || "").length <= 600 || i18n.t("descriptionLength")],
        referralNameRules: [(v) => (!v || (v.length >= 2 && v.length <= 40) ) || i18n.t("referralNameLength"), (v) =>( !v || /^([A-Za-zàâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]{1})+([[A-Za-zàâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]+[,.]?[ ]?|[A-Za-z]+['-àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]]?)+$/.test(v) ) || i18n.t("referralNameValid"),],
        referralPhoneRules: [(v) => (!v || (v.length >= 2 && v.length <= 100) ) || i18n.t("referralPhoneLength"), (v) =>( !v || /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v) ) || i18n.t("referralPhoneValid"),],
        streetRules: [(v) => !!v || i18n.t("formRules.address.required") , (v) => (!!v && v.length >= 2 && v.length <= 300) || i18n.t("formRules.address.nbCaracters")],
        zipRules: [(v) => !!v || i18n.t("formRules.zip.required") , (v) => /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$|^\d{5}(-\d{4})?$/.test(v) || i18n.t("formRules.zip.required")],
        cityRules:  [(v) => !!v || i18n.t("formRules.city.required"), (v) => (v && v.length >= 2 && v.length <= 100) || i18n.t("formRules.city.nbCaracters"),(v) => /^[a-zA-Z\s]+$/.test(v) || i18n.t("formRules.city.required")],
        stateRules:  [(v) => !!v || i18n.t("formRules.state.required"), (v) => (v && v.length >= 2 && v.length <= 100) || i18n.t("formRules.state.nbCaracters"),(v) => /^[a-zA-Z\s]+$/.test(v) || i18n.t("formRules.state.required")],
        countryRules: [(v) => !!v || i18n.t("formRules.country.required"), (v) => (v && v.length >= 2 && v.length <= 100) || i18n.t("formRules.country.nbCaracters"),(v) => /^[a-zA-Z\s]+$/.test(v) || i18n.t("formRules.country.required")],

        // cartSizeRules: [(v) => !!v || i18n.t("cartSizeRequired")],
        // cartQuantityRules: [(v) => v.value <= 1 <= 10 || i18n.t("cartQuantityRequired")],
        // pickupFrequencyRules: [(v) => !!v || i18n.t("pickupFrequencyRequired")],
        // businessTypeRules: [(v) => !!v || i18n.t("businessTypeRequired")],

        // startDateRules: [(v) => !!v || i18n.t("startDateRequired")],
        // pickupDateRules: [(v) => !!v || i18n.t("pickupDateRequired")],
        // deliveryDateRules: [(v) => !!v || i18n.t("deliveryDateRequired")],

        //dateRules: [(v) => !!v || this.$i18n.t("dateRequired"), (v) => new Date(v) >= new Date( new Date().getFullYear() - 1, new Date().getMonth(), new Date().getDate() ) || this.$i18n.t("formRules.date.invalid"), (v) => new Date(v) <= new Date( new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate() ) || this.$i18n.t("formRules.date.invalid"), (v) => /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/.test(v) || this.$i18n.t("formRules.date.invalid"), ],
        //dateCanadaRules: [ (v) => !!v || this.$i18n.t("dateRequired"), (v) => new Date( new Date(v).getFullYear(), new Date(v).getMonth(), new Date().getDate() ) >= new Date( new Date().getFullYear() - 1, new Date().getMonth(), new Date().getDate() ) || this.$i18n.t("formRules.date.invalid"), (v) => new Date(new Date(v).getFullYear(), new Date(v).getMonth(), new Date().getDate() ) <= new Date( new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate() ) || this.$i18n.t("formRules.date.invalid"), (v) => /^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))$/.test(v) || this.$i18n.t("formRules.date.invalid"),],
        //itemTypeRules: [(v) => !!v || i18n.t("itemTypeRequired")],
        quantityRules: [(v) => (v >= 0 || v >= 7) || i18n.t("quantityRequired")],
        //optionalQuantityRules: [(v) => (v >= 0 || v >= 7) || i18n.t("quantityRequired")],
      };
    },
    hoas() {
      if (!this.form.hoa) {
        return null;
      } else {
        return Object.keys(this.form.hoa)
          .map((key) => {
            return {
              key,
              value: this.form.hoa[key] || "",
            };
          })
          .filter((item) => item.key === "message");
      }
    },
    isConstruction() {
      const leadType = this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType);
      // (leadType==='Construction' || leadType==='Commercial')&&!this.form.menuNavigationId.includes('Storefront');
      return leadType==='Construction' || leadType==='Commercial' || leadType==='Portable Toilet';
    },
    showGetAQuote() {
        if (this.currentTabComponent !== 'ServiceView' && this.currentTabComponent !== 'AddressView' && this.currentTabComponent !== 'DetailView') {
            if (!this.form.menuNavigationId) {
                return true;
            }
            if (this.form.menuNavigationId && !this.haveServicesForThisType()) {
                return true;
            }
            if (this.form.menuNavigationId && this.haveServicesForThisType() && this.isConstruction) {
                return true;
            }
        }
        return false;
    },
    showGoToStore() {
        return this.form.menuNavigationId && this.haveServicesForThisType() && !['ServiceView', 'AddressView', 'DetailView'].includes(this.currentTabComponent);
    },
  },
  actions: {
    //  ***********************************************
    //  GENERAL FUNCTIONS FOR ANY PROJECT
    //  ***********************************************
    // Update view of current component
    updateViewComponent(component, skipScroll) {

      this.currentTabComponent = component;
      if(!skipScroll){
        this.scrollToTop();
      }

    },

    // Auto format for phone number. Adds parentheses and dashes
    acceptNumber() {

      var x = this.form.phone.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      this.form.phone = !x[2]
        ? x[1]
        : "(" + x[1] + ")" + x[2] + (x[3] ? "-" + x[3] : "");

    },

    // remove special characters and white space
    formatPhone(phoneNumber){

      var str = phoneNumber.replace(/[^a-zA-Z0-9 ]/g, "");
      return str;

    },

    // Scroll to widget
    scrollToTop() {
      document.getElementById('scrollToEmbed').scrollIntoView({behavior: "instant"});
    },

    // Format date for request quote widget
    formatDate(date, iso, fieldDate) {
      if (fieldDate == "wantedDeliveryDateFormatted") {
        if (iso === "en_CA") {
          this.form.wantedDeliveryDateFormatted =
            date.substring(0, 4) +
            "-" +
            date.substring(5, 7) +
            "-" +
            date.substring(8, 10);
        } else {
          this.form.wantedDeliveryDateFormatted =
            date.substring(5, 7) +
            "/" +
            date.substring(8, 10) +
            "/" +
            date.substring(0, 4);
        }
      }
      if (fieldDate == "wantedEndDateFormatted") {
        if (iso === "en_CA") {
          this.form.wantedEndDateFormatted =
            date.substring(0, 4) +
            "-" +
            date.substring(5, 7) +
            "-" +
            date.substring(8, 10);
        } else {
          this.form.wantedEndDateFormatted =
            date.substring(5, 7) +
            "/" +
            date.substring(8, 10) +
            "/" +
            date.substring(0, 4);
        }
      }
      if (fieldDate == "wantedStartDateFormatted") {
        if (iso === "en_CA") {
          this.form.wantedStartDateFormatted =
            date.substring(0, 4) +
            "-" +
            date.substring(5, 7) +
            "-" +
            date.substring(8, 10);
        } else {
          this.form.wantedStartDateFormatted =
            date.substring(5, 7) +
            "/" +
            date.substring(8, 10) +
            "/" +
            date.substring(0, 4);
        }
      }
      if(!fieldDate){
        if (iso === "en_CA") {
          return (
            date.substring(0, 4) +
            "-" +
            date.substring(5, 7) +
            "-" +
            date.substring(8, 10)
          );
        } else {
          return (
            date.substring(5, 7) +
            "/" +
            date.substring(8, 10) +
            "/" +
            date.substring(0, 4)
          );
        }
      }
    },

    // Update and do the action depending on the web lead step
    updateStages(webLeadStep, keepLead = true) {
      this.loading = true;
      var vm = this;
      vm.form.webLeadStep = webLeadStep;

      // Stage 1
      if(webLeadStep == 'Address Stage') {
        this.fbEventId = this.generateUniqueFbEventId();
        vm.reCaptchaValidation('validationQuote');
      }
      // Stage 2
      if(webLeadStep == 'Service Stage' || webLeadStep == 'Redirect Stage') {
        let leadType = vm.getLeadTypeFromServiceType(vm.form.serviceType,vm.form.categoryType);
        vm.sortServicePackges(leadType);
        if(keepLead){
          vm.sendHttpRequestQuote('LeadInformation',useAxiosFormStore().getDataToAxios());
        }else{
          this.apiResult = cloneDeep(this.apiResultOriginal);
          this.loading = false;
        }
      }
      // Stage 3
      if(webLeadStep == 'Details Stage') {
        vm.updatedServicesWantedForm();
        if((vm.form.serviceType == 'Commercial' && vm.form.menuNavigationId == 'WasteRecyPickUp' && vm.form.servicesWantedWithPricing) || (vm.component === 'commercial')){
          vm.updateViewComponent("ProcessingOrder");
          vm.sendHttpRequestQuote('PriceInformation',useAxiosFormStore().getDataToAxios());
        } else{
          vm.sendHttpRequestQuote('LeadInformation',useAxiosFormStore().getDataToAxios());
        }
      }
    },

    // go to previous component and reset some data
    back(skip) {

      if(this.form.webLeadStep == "Address Stage"){

        this.form.webLeadStep = '';
        this.form.categoryType = '';

      }
      if(this.form.webLeadStep == "Service Stage"){

        this.form.webLeadStep = 'Address Stage';


      }
      if(this.form.webLeadStep == "Redirect Stage"){

        this.form.webLeadStep = 'Service Stage';

      }

      this.loading = false;
      this.form.wantedQtyErr = false;
      this.form.menuNavigationId = null;
      this.apartmentsCondosHoas = false;

      //reset form from "add more detail btn"
      this.completeAddressMsg = '';
      this.serviceFormErrors = false;
      this.form.serviceForm = [];
      this.form.wantedSize = {};
      this.form.wantedQty = 0;
      this.form.businessName = '';
      this.form.wantedFrequency = {};
      this.form.servicesWantedJSON = null;
      this.form.businessType = '';
      this.form.serviceDetail = '';

      this.form.wantedStartDate= "";
      this.form.wantedStartDateMenu = false;
      this.form.wantedStartDateFormatted= "";

      this.form.wantedDeliveryDate= "";
      this.form.wantedDeliveryDateMenu = false;
      this.form.wantedDeliveryDateFormatted= "";

      this.form.wantedEndDate= "";
      this.form.wantedEndDateMenu = false;
      this.form.wantedEndDateFormatted= "";

      this.apiResult = cloneDeep(this.apiResultOriginal);

      // Reset all the sizes from third step
      reset.sizes();

      if(!skip){
        this.form.menuOrder.pop();
      }

      this.trackViewSplitter = '';

      if(!skip){
        const component = this.form.menuOrder[this.form.menuOrder.length - 1];
        const componentDoubleBack = this.form.menuOrder[this.form.menuOrder.length - 2];
        if(component.includes('ResiStorefront') || component.includes('CommStorefront')){
          this.form.menuOrder.pop();
          this.updateViewComponent(componentDoubleBack);
        }else{
          this.updateViewComponent(component);
        }
      }

      this.scrollToTop();
    },

    // facebook event
    fbqSendEvents(type) {
      if (typeof window.parent.fbq !== "undefined") {
        if(type==='location'){
          window.parent.fbq('track', 'FindLocation')
        }else{
          if(this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType)==='Residential'){
            window.parent.fbq('trackCustom', 'Lead Residential', {eventID: this.fbEventId});
          }
          if(this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType)==='Commercial'){
            window.parent.fbq('trackCustom', 'Lead Commercial', {eventID: this.fbEventId});
          }
          if(this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType)==='Construction'){
            window.parent.fbq('trackCustom', 'Lead Construction', {eventID: this.fbEventId});
          }

        }
      }
    },

    //  ***********************************************
    //  Data packages from waste connection
    //  ***********************************************
    getLeadTypeFromServiceType(defaultService, categorieType) {
      // const isCommercial = this.containServicePackgesOf('commercial', true);
      const isYard = this.residentialMhoamWantedForm.some(form => form.size?.binSize?.toLowerCase().includes('yard'));
      let leadType = "";

      if(defaultService==="Residential") {

        switch(categorieType) {
          case 'Apartments, Condos & HOAs':
            if(isYard){ // isCommercial
              leadType = 'Commercial';
            }else{
              leadType = 'Residential';
            }
            break;
          case 'Dumpster Rental (Remodels, Construction, Etc.)':
            leadType = 'Construction';
            break;
          case 'Portable Toilets':
            leadType = 'Portable Toilet';
            break;
          case 'Shredding':
            leadType = 'Shredding';
            break;
          default:
            leadType = defaultService;
        }
        return leadType;

      }

      if(defaultService==="Commercial"){

        switch(categorieType) {
          case 'Dumpster Rental (Construction, Bulky Pickup, Etc.)':
            leadType = 'Commercial';
            break;
          case 'Portable Toilets':
            leadType = 'Portable Toilet';
            break;
          case 'Shredding':
            leadType = 'Shredding';
            break;
          default:
            leadType = defaultService;
        }

      }
      if(defaultService==="Roll Off" && this.component.includes('rolloff')){

        leadType = 'Construction'

      }
      return leadType;
    },

    sortServicePackges(leadType) {
      var vm = this;

      if(vm.apiResult.storeFrontURL){

        const RESI = 'RESIDENTIAL';
        const COMM = 'COMMERCIAL';
        const CONST = 'CONSTRUCTION';
        const TEMP = 'TEMP ROLL OFF';
        const TOILET = 'PORTABLE TOILET';
        const SERVICECONST = leadType.toUpperCase()===CONST?TEMP:leadType.toUpperCase();

        if(leadType.toUpperCase()===RESI){

          vm.getServicePackges(RESI);

        }else if(leadType.toUpperCase()===COMM){

          vm.getServicePackges(COMM);

        } else if(leadType.toUpperCase()===CONST){

          vm.getServicePackges(SERVICECONST);

        }else if(leadType.toUpperCase()===TOILET){

          vm.getServicePackges(TOILET+'S');

        }else{

          reset.apiStoreData(true);

        }
      }
    },

    // Defaults to the clicked service, step 2 also passes a row's category and name before the click (store icon)
    haveServicesForThisType(categoryType = this.form.categoryType, menuNavigationId = this.form.menuNavigationId){
      var vm = this;
      if(vm.apiResult.storeFrontURL && menuNavigationId !== 'BulkPickUp' && menuNavigationId !== "SomethingElse"){

        const RESI = 'RESIDENTIAL';
        const COMM = 'COMMERCIAL';
        const CONST = 'CONSTRUCTION';
        const TEMP = 'TEMP ROLL OFF';
        const TOILET = 'PORTABLE TOILET';
        let leadType = vm.getLeadTypeFromServiceType(vm.form.serviceType,categoryType);

        if(leadType.toUpperCase()===RESI&&!vm.duplicateCustomerCheck()){

          return vm.apiResult?.data?.ServicePackges?.filter(o => o.LineOfBusiness===RESI).length;

        }else if(leadType.toUpperCase()===COMM&&!vm.duplicateCustomerCheck()){

          return vm.apiResult?.data?.ServicePackges?.filter(o => o.LineOfBusiness===COMM).length;

        } else if(leadType.toUpperCase()===CONST){

          return vm.apiResult?.data?.ServicePackges?.filter(o => o.LineOfBusiness===TEMP).length;

        } else if(leadType.toUpperCase()===TOILET){

          return vm.apiResult?.data?.ServicePackges?.filter(o => o.LineOfBusiness===TOILET+'S').length;

        }
      }
    },
    containServicePackgesOf(type, original = false){
      let dataSource = original ? this.apiResultOriginal.data : this.apiResult.data;
      if(dataSource && dataSource.ServicePackges){
        return dataSource.ServicePackges.filter(o => o.LineOfBusiness===this.getRealNameFromPackages(type)).length?true:false
      }
      return null;
    },
    duplicateCustomerCheck(forLeadInfo){
      const result = this.apiResult.data && this.apiResult.data.StoreFrontSetting && this.apiResult.data.StoreFrontSetting.EnableDuplicateCustomerCheck && this.apiResult.data.ExistingAccounts && this.apiResult.data.ExistingAccounts.length > 0;
      const resultOriginal = this.apiResultOriginal.data && this.apiResultOriginal.data.StoreFrontSetting && this.apiResultOriginal.data.StoreFrontSetting.EnableDuplicateCustomerCheck && this.apiResultOriginal.data.ExistingAccounts && this.apiResultOriginal.data.ExistingAccounts.length > 0;
      const resultLead = this.apiResult.data && this.apiResult.data.ExistingAccounts && this.apiResult.data.ExistingAccounts.length > 0;
      const resultOriginalLead = this.apiResultOriginal.data && this.apiResultOriginal.data.ExistingAccounts && this.apiResultOriginal.data.ExistingAccounts.length > 0;

      if(forLeadInfo){
        return resultLead || resultOriginalLead;
      }

      return result || resultOriginal;
    },
    getRealNameFromPackages(name){
      const RESI = 'RESIDENTIAL';
      const COMM = 'COMMERCIAL';
      const CONST = 'CONSTRUCTION';
      const TEMP = 'TEMP ROLL OFF';
      const TOILET = 'PORTABLE TOILET';
      const SHRED = 'SHREDDING';
      if(name.toUpperCase()===RESI){
        return RESI;
      }else if(name.toUpperCase()===COMM){
        return COMM;
      } else if(name.toUpperCase()===CONST){
        return TEMP;
      } else if(name.toUpperCase()===TOILET){
        return TOILET+'S';
      } else if(name.toUpperCase()===SHRED){
        return SHRED;
      }
    },

    getServicePackges(type){
      var vm = this;
      vm.apiResult.data.ServicePackges = vm.apiResult?.data?.ServicePackges?.filter(o => o.LineOfBusiness===type);

      if(!vm.apiResult.data.ServicePackges?.length){
        
        reset.apiStoreData(true);

      }
    },

    // Send request data to salesforce for update/create lead
    async sendHttpRequestQuote(apiName,json) {
      this.apiName = apiName
      this.orderView = "processing";
      this.loading = true;
      let vm = this;

      if(apiName == 'LeadInformation') {
        if(json.servicesWantedJSON){
          json.servicesWantedJSON = JSON.stringify(json.servicesWantedJSON);
        }

        try{
          if(!json.leadExternalId){
            const response = await salesforce.sendHttpRequestQuote(apiName,json);
            if (response.status === 200) {
              if (response.data && response.data.includes("EID-")) {
                // Check if data exist and data is truly an ID
                vm.form.leadExternalId = response.data;
              }
            }
          }else{
              if(vm.form.menuNavigationId === 'CommStorefront'){
                storefront.redirectToStoreFrontLead();
              }else{
                salesforce.sendHttpRequestQuote(apiName,json);
              }
          }
        }catch (error) {
          // If error, make true to display error message
          vm.errorAxios = true;
          vm.dialog = false;
          vm.loading = false;
          vm.snackbar = true;
          console.log(error);
        }

        // Request quote form fill
        if (vm.form.serviceType && vm.form.address && vm.form.email && vm.form.categoryType && vm.form.firstName && vm.form.lastName &&
          (vm.form.menuOrder.length === 3 && !vm.form.menuOrder.includes('ResiStorefront') && !vm.form.menuOrder.includes('CommStorefront')) ||
          (vm.form.menuOrder.length === 4 && vm.form.menuOrder.includes('ResiStorefront') || vm.form.menuOrder.length === 4 && vm.form.menuOrder.includes('CommStorefront'))) {

          // Send data to google analytics and intellimize and facebook for tracking
          googleApi.gTagSendEvents(vm.getLeadTypeFromServiceType(vm.form.serviceType,vm.form.categoryType).toLowerCase(),0,'Lead Created',process.env.VUE_APP_GTAG_LEAD_CATEGORY,vm.getLeadTypeFromServiceType(vm.form.serviceType,vm.form.categoryType),vm.form.categoryType, vm.apiResult.districtID);
          intellimize.sendIntellimizeEvent('lead_created');

          // Send specific lead type event
          const leadType = vm.getLeadTypeFromServiceType(vm.form.serviceType, vm.form.categoryType);
          if (leadType === 'Residential') {
            intellimize.sendIntellimizeEvent('resi_lead_created');
          } else if (leadType === 'Commercial') {
            intellimize.sendIntellimizeEvent('comm_lead_created');
          } else if (leadType === 'Construction') {
            intellimize.sendIntellimizeEvent('roll_off_lead_created');
          }

          vm.fbqSendEvents("");

          if(vm.form.servicesWantedOfferStatus) {

            switch(vm.form.servicesWantedOfferStatus) {
              case 'Accepted':
                // vm.updateViewComponent("ThankyouExplore");
                vm.orderView = 'summaryService'
                break;
              case 'Refused':
                vm.orderView = 'feedback'
                break;
            }

          } else {

            vm.updateViewComponent("ThankyouExplore");

          }
          vm.resetAll();

          vm.dialog = false;
        }
        // Dumpster Commercial form fill
        if (vm.form.serviceType && vm.form.address && vm.form.email && vm.form.firstName && vm.form.lastName && vm.component === 'commercial') {

          // Send data to google analytics and intellimize and facebook for tracking
          googleApi.gTagSendEvents(vm.getLeadTypeFromServiceType(vm.form.serviceType,vm.form.categoryType).toLowerCase(),0,'Lead Created',process.env.VUE_APP_GTAG_LEAD_CATEGORY,vm.getLeadTypeFromServiceType(vm.form.serviceType,vm.form.categoryType),vm.form.categoryType, vm.apiResult.districtID);
          intellimize.sendIntellimizeEvent('lead_created');

          // Send specific lead type event
          const leadType = vm.getLeadTypeFromServiceType(vm.form.serviceType, vm.form.categoryType);
          if (leadType === 'Residential') {
            intellimize.sendIntellimizeEvent('resi_lead_created');
          } else if (leadType === 'Commercial') {
            intellimize.sendIntellimizeEvent('comm_lead_created');
          } else if (leadType === 'Construction') {
            intellimize.sendIntellimizeEvent('roll_off_lead_created');
          }

          vm.fbqSendEvents("");

          if(vm.form.servicesWantedOfferStatus) {

            switch(vm.form.servicesWantedOfferStatus) {
              case 'Accepted':
                vm.updateViewComponent("ThankyouExplore");
                break;
              case 'Refused':
                vm.orderView = 'feedback'
                break;
            }

          } else {

            vm.updateViewComponent("ThankyouExplore");

          }
          vm.resetAll();

          vm.dialog = false;
        }

        // Roll Off form fill
        if (vm.addressVerified && vm.form.address && vm.form.email && vm.form.firstName && vm.form.lastName && vm.form.acceptConditions && (vm.component === 'rolloff' || vm.component === 'rolloffwizard')) {

          // Send data to google analytics and intellimize and facebook for tracking
          googleApi.gTagSendEvents(vm.getLeadTypeFromServiceType(vm.form.serviceType,vm.form.categoryType).toLowerCase(),0,'Lead Created',process.env.VUE_APP_GTAG_LEAD_CATEGORY,vm.getLeadTypeFromServiceType(vm.form.serviceType,vm.form.categoryType),vm.form.categoryType, vm.apiResult.districtID);
          intellimize.sendIntellimizeEvent('lead_created');

          // Send specific lead type event
          const leadType = vm.getLeadTypeFromServiceType(vm.form.serviceType, vm.form.categoryType);
          if (leadType === 'Residential') {
            intellimize.sendIntellimizeEvent('resi_lead_created');
          } else if (leadType === 'Commercial') {
            intellimize.sendIntellimizeEvent('comm_lead_created');
          } else if (leadType === 'Construction') {
            intellimize.sendIntellimizeEvent('roll_off_lead_created');
          }

          vm.fbqSendEvents("");

          if(vm.form.servicesWantedOfferStatus) {

            switch(vm.form.servicesWantedOfferStatus) {
              case 'Accepted':
                vm.resetAll();
                vm.updateViewComponent("ThankyouExplore");
                break;
              case 'Refused':
                vm.orderView = 'feedback'
                break;
            }

          } else if(vm.component !== 'rolloffwizard') {

                vm.updateViewComponent("ThankyouExplore");
                vm.resetAll();

          }

          vm.dialog = false;
        }


        if ((vm.form.menuNavigationId || vm.form.selectedTypeId) && vm.form.menuNavigationId != "BulkPickUp" && vm.form.menuNavigationId != "SomethingElse") {

          vm.form.menuOrder.push(vm.form.menuNavigationId || vm.form.selectedTypeId);
          vm.updateViewComponent( vm.form.menuNavigationId || vm.form.selectedTypeId);
          vm.dialog = false;
          vm.loading = false;
        }

        // Residential option sent to contact us form of Bulk Item Pickup
        if(vm.form.menuNavigationId === 'BulkPickUp'){

          // Reset Contact View Name to prevent bug where view was not becoming BulkItemPickup
          useContactUsStore().view.name = '';
          vm.servicefromquote = "bulkItemPickup"
          vm.currentTabComponent = 'ContactWidgetV3'
          vm.component = "contact"
          vm.dialog = false;
          vm.loading = false;

        }

        // Business's Last option in menu
        // will send to contact us menu
        if(vm.form.menuNavigationId == "SomethingElse") {

          vm.servicefromquote = "quote"
          vm.currentTabComponent = 'ContactWidgetV3'
          vm.component = "contact"
          vm.dialog = false;
          vm.loading = false;

        }
      } else if(apiName == 'PriceInformation'){

        // Send data to backend and get the response to triggle code
        await salesforce.sendHttpRequestQuote(apiName, json)
        .then((response) => {
          if (response.data && response.data.leadExternalId.includes("EID-")) {
            // Bind external ID if it has been created
            vm.form.leadExternalId = response.data.leadExternalId;

          }

          // Get the response data and check if the pricing is available
          if(response.data.servicesWantedPricingAvailable){

            // Get the data updated from back-end side to front-end
            // with the response of the price if it exist or not
            vm.form.servicesWantedJSON = response.data.servicesWantedJSON
            vm.form.servicesWantedPricingAvailable = response.data.servicesWantedPricingAvailable;

            // If the price doesn't exist,
            // skip the view with the prices and summary
            if(!vm.form.servicesWantedWithPricing){

              vm.updateViewComponent("ThankyouExplore");
              vm.resetAll();

            }else{

              // Show view of the summary
              vm.orderView = "confirmationEmail";
              vm.form.servicesWantedOfferStatus = response.data.servicesWantedOfferStatus;

            }

          } else {
            // Send data to google analytics and intellimize and facebook for tracking
            googleApi.gTagSendEvents(vm.getLeadTypeFromServiceType(vm.form.serviceType,vm.form.categoryType).toLowerCase(),0,'Lead Created','Start Service',vm.getLeadTypeFromServiceType(vm.form.serviceType,vm.form.categoryType),vm.form.categoryType, vm.apiResult.districtID);
            intellimize.sendIntellimizeEvent('lead_created');

            // Send specific lead type event
            const leadType = vm.getLeadTypeFromServiceType(vm.form.serviceType, vm.form.categoryType);
            if (leadType === 'Residential') {
              intellimize.sendIntellimizeEvent('resi_lead_created');
            } else if (leadType === 'Commercial') {
              intellimize.sendIntellimizeEvent('comm_lead_created');
            } else if (leadType === 'Construction') {
              intellimize.sendIntellimizeEvent('roll_off_lead_created');
            }

            vm.fbqSendEvents("");

            // Continue to the next view
            vm.updateViewComponent("ThankyouExplore");
            vm.resetAll();
          }

          vm.loading = false;

        }).catch(function (error) {
          if (error) {
            vm.loading = false;
            vm.errorAxios = true;
          }
          vm.loading = false;
          vm.snackbar = true;
          console.log(error);
        });
      }
    },

    // *******************************************************
    // Google
    // *******************************************************
    // RECAPTCHA

    reCaptchaValidation(dataAction){

      this.loading = true;
      var vm = this;

      load(process.env.VUE_APP_RECAPTCHA).then((recaptcha) => {
        recaptcha.execute(dataAction).then(function (token) {
          axios
            .post(
              process.env.VUE_APP_RESTURL + "services/apexrest/ServiceProvidedSearch",
              {
                callType: "validation",
                validationObject: { token: token },
              }
            )
            .then(function (response) {

              if (response.status === 200) {

                var data = JSON.parse(response.data);

                if (dataAction === 'validationQuote' && window.parent.google_tag_manager && typeof window.parent.dataLayer !== "undefined") {
                    window.parent.dataLayer = window.parent.dataLayer || [];
                    window.parent.dataLayer.push({
                      event: 'eventTracking',
                      action: 'Submit Address',
                      event_category: process.env.VUE_APP_GTAG_LEAD_CATEGORY,
                      event_label: vm.getLeadTypeFromServiceType(vm.form.serviceType,vm.form.categoryType),
                      value: 0,
                      lead_type: vm.form.serviceType,
                      lead_category: vm.form.categoryType,
                      lead_district: vm.apiResult.districtID
                    });

                    if (data.success && data.action === dataAction && data.score >= 0.3){
                      if(vm.component === 'contact'){

                        useContactUsStore().verifyGoogleAddress('address');

                      } else{

                        vm.verifyGoogleAddress();

                      }

                    } else {
                      vm.recaptchaDialog = true;
                      vm.loading = false;
                    }

                } else {

                  if (data.success && data.action === dataAction && data.score >= 0.3){
                    if(vm.component === 'contact'){

                      useContactUsStore().verifyGoogleAddress('address');

                    } else{

                      vm.verifyGoogleAddress();

                    }

                  } else {
                    vm.recaptchaDialog = true;
                    vm.loading = false;

                  }

                }

              }
              if(vm.component === 'contact'){
                vm.loading = false;
              }
            })
            .catch(function (error) {

              vm.loading = false;
              console.log(error);

            });
        });
      });
    },
    // Check address and push multiple addresses in a array
    verifyGoogleAddress() {
          this.loading = true;

          // return promises response
          googleApi.autocompleteSuggestions(this.google, this.form.address).then((result) => {
          // check promises
          if (result.status == 'OK') {

            if (result.predictions.length === 1) {

              googleApi.gTagSendEvents("1 Address",0,"Address Response",process.env.VUE_APP_GTAG_LEAD_CATEGORY,this.form.serviceType,this.form.categoryType,this.apiResult.districtID);
              this.getAddressPrediction(this.google, result.predictions[0].description);
            } else if (result.predictions[0].description === this.form.address) {

              googleApi.gTagSendEvents("1 Address",0,"Address Response",process.env.VUE_APP_GTAG_LEAD_CATEGORY,this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType),this.form.categoryType,this.apiResult.districtID);
              this.getAddressPrediction(this.google,result.predictions[0].description);

            } else {

              googleApi.gTagSendEvents("Multiple Address",0,"Address Response",process.env.VUE_APP_GTAG_LEAD_CATEGORY,this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType),this.form.categoryType,this.apiResult.districtID);

              var currentAddress = {
                  description: "other",
                  structured_formatting: {
                  main_text: i18n.t("continueWithThisAddress"),
                  secondary_text: this.form.address,
                },
              }

              result.predictions.push(currentAddress);
              this.form.predictions = result.predictions;
              this.viewForm("prediction");
              this.servicesLookupLine = "";
              this.apiResult = {
                data: null,
                storeFrontURL: "",
                districtID: "",
              },
              this.apiResultOriginal = {
                data: null,
                storeFrontURL: "",
                districtID: "",
              },
              this.loading = false;

            }
          } else {
            this.completeAddressMsg = i18n.t("completeAddressRequired");
            this.loading = false;
          }
        })
        .catch((error) => {
          console.error("Error getting address suggestions:", error);
          this.completeAddressMsg = i18n.t("completeAddressRequired");
          this.loading = false;
        });
    },

    // Get the selected address from selects/options list and bind them to their variables
    getAddressPrediction(google,prediction){
          this.loading = true;
          this.servicesLookupLine = "";

          googleApi.selectedPrediction(google, prediction).then((result) => {

              // check promises
            if (result.status == "OK") {

              // if address is found, split address in parts
              this.form.streetNumber = result.streetNumber;
              this.form.route = result.route;
              this.form.street = result.streetNumber + " " + result.route;
              this.form.city = result.city;
              this.form.state = result.state;
              this.form.zip = result.zip;
              this.form.country = result.country;
              this.form.lat = result.lat;
              this.form.lng = result.lng;
              this.form.address = result.address;

              if (this.assigntodistrict) {

                this.findTheDistrict(this.assigntodistrict);

              }

              let skip = (this.form.serviceType === "Commercial" && this.form.country.toLowerCase()==='Canada') || this.form.serviceType === "shredding" ? false : true;

              if (skip) {

                this.servicesLookupLine = this.getServicesLine();
                this.findAvailableServices(this.newStoreApi,this.form.street,this.form.city,this.form.zip,this.form.lat,this.form.lng,this.servicesLookupLine,this.storefrontDistrictCodeOverride,"","","","",this.form.country === "Canada" ? "FR" : "EN",this.form.state);

              } else {

                googleApi.gTagSendEvents(
                  this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType).toLowerCase(),
                  0,
                  "Display Services List",
                  process.env.VUE_APP_GTAG_LEAD_CATEGORY,
                  this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType),
                  this.form.categoryType,
                  this.apiResult.districtID
                );


                if(this.component === 'commercial' && this.currentTabComponent === 'DetailDumpster'){

                  this.updateStages('Details Stage');

                } else{

                  this.sendHttpRequestQuote('LeadInformation',useAxiosFormStore().getDataToAxios());

                }
              }

            } else {

              googleApi.gTagSendEvents("Not Found", 0,"Address Response", process.env.VUE_APP_GTAG_LEAD_CATEGORY, this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType),this.form.categoryType,this.apiResult.districtID);
              this.form.street ||= this.form.address;
              let himself = this.form.address;
              this.form.address = himself;
              reset.apiStoreData();
              this.sendHttpRequestQuote('LeadInformation',useAxiosFormStore().getDataToAxios());

            }
          });
    },

    viewForm(viewFormSelected,skipScroll) {

      this.view.prediction = false;
      this.view.hoa = false;
      this.view.tenant = false;
      this.view.hoaAndTenant = false;
      this.dialog = false;

      if (viewFormSelected === "prediction") {

        this.view.prediction = true;
        this.dialog = true;

      }
      if (viewFormSelected === "hoa") {

        this.view.hoa = true;
        this.dialog = true;

      }
      if (viewFormSelected === "tenant") {

        this.view.tenant = true;
        this.dialog = true;

      }
      if (viewFormSelected === "hoaAndTenant") {

        this.view.hoaAndTenant = true;
        this.dialog = true;

      }
      if (!skipScroll) {

        this.scrollToTop();

      }
    },

    //  ********************************************************
    //  STOREFRONT
    //  ********************************************************
    // Line of business sent to the address lookup for the current serviceType/categoryType
    getServicesLine() {
      return this.getRealNameFromPackages(this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType))?.toUpperCase() || "";
    },

    // Re-run the address lookup when the category picked on step 2 needs another line of business
    // than the one fetched from ServiceView (e.g. Portable Toilets under Curbside Collection).
    // Only refreshes the packages/storefront data, without the navigation done by findAvailableServices.
    async refreshServicesForCategory() {
      const line = this.getServicesLine();

      // servicesLookupLine is empty when the current address had no lookup (not found, predictions)
      // BulkPickUp and SomethingElse go to the contact form and don't use the packages
      if (!line || !this.servicesLookupLine || line === this.servicesLookupLine || !this.addressVerified || this.form.menuNavigationId === 'BulkPickUp' || this.form.menuNavigationId === "SomethingElse") {
        return;
      }

      // Skip very specific districts to go to storefront
      const districtsToSkip = ['7151', '7110'];
      this.loading = true;

      try {
        const response = await storefront.findAvailableServices(this.newStoreApi,this.form.street,this.form.city,this.form.zip,this.form.lat,this.form.lng,line,this.storefrontDistrictCodeOverride,"","","","",this.form.country === "Canada" ? "FR" : "EN",this.form.state);

        if (response.status === 200 && this.isJsonValid(response.data)) {
          this.servicesLookupLine = line;
          this.apiResult.data = JSON.parse(response.data);
          this.apiResultOriginal.data = JSON.parse(response.data);

          const data = this.apiResult.data;
          const hasStore = data && data.District && !districtsToSkip.includes(data.District.replace('A', '')) && data.StoreFrontSetting && data.DistrictDetail && data.DistrictDetail.storefrontLink && data.ServicePackges && data.ServicePackges.length > 0;

          if (data && data.District) {
            this.apiResult.districtID = data.District;
            this.apiResultOriginal.districtID = data.District;
          }

          if (hasStore) {
            this.apiResult.storeFrontURL = data.DistrictDetail.storefrontLink;
            this.apiResultOriginal.storeFrontURL = data.DistrictDetail.storefrontLink;

            if (data.StoreFrontSetting.EnableDuplicateCustomerCheck && data.ExistingAccounts && data.ExistingAccounts.length > 0 && !this.containServicePackgesOf('construction')) {
              reset.apiStoreData(true);
            }
          } else {
            this.apiResultOriginal.storeFrontURL = "";
            reset.apiStoreData(true);
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    // Check available services for WC after entering address
    findAvailableServices(callType, address, city, zip, latitude, longitude, line,district,lastName,firstName,email,phone,displayLanguage,state) {
      this.loading = true;
      let vm = this;

      // Skip very specific districts to go to storefront
      const districtsToSkip = ['7151', '7110'];

      storefront.findAvailableServices(callType,address,city,zip,latitude,longitude,line,district,lastName,firstName,email,phone,displayLanguage,state).then((response) => {

        if (response.status === 200 && vm.isJsonValid(response.data)) {
          vm.apiResult.data = JSON.parse(response.data);
          vm.apiResultOriginal.data = JSON.parse(response.data);

          if (vm.apiResult.data && vm.apiResult.data.District && !districtsToSkip.includes(vm.apiResult.data.District.replace('A', '')) && vm.apiResult.data.StoreFrontSetting && vm.apiResult.data.DistrictDetail && vm.apiResult.data.ServicePackges && vm.apiResult.data.DistrictDetail.storefrontLink && vm.apiResult.data.ServicePackges.length > 0 ) {

            vm.apiResult.storeFrontURL = vm.apiResult.data.DistrictDetail.storefrontLink;
            vm.apiResult.districtID = vm.apiResult.data.District;
            vm.apiResultOriginal.storeFrontURL = vm.apiResultOriginal.data.DistrictDetail.storefrontLink;
            vm.apiResultOriginal.districtID = vm.apiResultOriginal.data.District;

            if(vm.apiResult.data.StoreFrontSetting && vm.apiResult.data.StoreFrontSetting.Storefront_HOA_Enabled && !vm.apiResult.data.StoreFrontSetting.EnableCustomerTenantCheck && vm.form.serviceType === "Residential") {

              googleApi.gTagSendEvents(
                this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType).toLowerCase(),
                0,
                "Display Homeowner Association",
                process.env.VUE_APP_GTAG_LEAD_CATEGORY,
                this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType),
                this.form.categoryType,
                this.apiResult.districtID
              );

              vm.loading = false;
              this.viewForm('hoa');

            } else if (vm.apiResult.data.StoreFrontSetting && !vm.apiResult.data.StoreFrontSetting.Storefront_HOA_Enabled && vm.apiResult.data.StoreFrontSetting.EnableCustomerTenantCheck && vm.form.serviceType === "Residential") {

              googleApi.gTagSendEvents(
                this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType).toLowerCase(),
                0,
                "Display Tenant",
                process.env.VUE_APP_GTAG_LEAD_CATEGORY,
                this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType),
                this.form.categoryType,
                this.apiResult.districtID
              );

              vm.loading = false;
              this.viewForm('tenant');

            } else if (vm.apiResult.data.StoreFrontSetting && vm.apiResult.data.StoreFrontSetting.Storefront_HOA_Enabled && vm.apiResult.data.StoreFrontSetting.EnableCustomerTenantCheck && vm.form.serviceType === "Residential") {

              googleApi.gTagSendEvents(
                this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType).toLowerCase(),
                0,
                "Display Homeowner Association And Tenant",
                process.env.VUE_APP_GTAG_LEAD_CATEGORY,
                this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType),
                this.form.categoryType,
                this.apiResult.districtID
              );

              vm.loading = false;
              this.viewForm('hoaAndTenant');

            }else {
              googleApi.gTagSendEvents(
                this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType).toLowerCase(),
                0,
                "Display Services List",
                process.env.VUE_APP_GTAG_LEAD_CATEGORY,
                this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType),
                this.form.categoryType,
                this.apiResult.districtID
              );

              if (vm.apiResult.data.StoreFrontSetting && vm.apiResult.data.StoreFrontSetting.EnableDuplicateCustomerCheck && vm.apiResult.data.ExistingAccounts && vm.apiResult.data.ExistingAccounts.length > 0 && !vm.containServicePackgesOf('construction')) {

                reset.apiStoreData(true);
                vm.loading = false;

              }
              if(vm.component === 'commercial' && vm.currentTabComponent === 'DetailDumpster'){

                vm.updateStages('Details Stage');
                vm.loading = false;

              } else if(vm.component === 'quote') {

                vm.sendHttpRequestQuote('LeadInformation',useAxiosFormStore().getDataToAxios());

              }else {

                vm.loading = false;

              }
            }
          } else {

            googleApi.gTagSendEvents(
              this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType).toLowerCase(),
              0,
              "Display Services List",
              process.env.VUE_APP_GTAG_LEAD_CATEGORY,
              this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType),
              this.form.categoryType,
              this.apiResult.districtID
            );

            vm.apiResult.districtID = vm.apiResult.data.District;
            vm.apiResultOriginal.districtID = vm.apiResultOriginal.data.District;
            reset.apiStoreData(true);

            if(vm.component === 'commercial' && vm.currentTabComponent === 'DetailDumpster'){

              vm.updateStages('Details Stage');
              vm.loading = false;

            } else if(vm.component === 'quote') {

              vm.sendHttpRequestQuote('LeadInformation',useAxiosFormStore().getDataToAxios());

            }else {

              vm.loading = false;

            }
          }
        } else {
          googleApi.gTagSendEvents(
            this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType).toLowerCase(),
            0,
            "Display Services List",
            process.env.VUE_APP_GTAG_LEAD_CATEGORY,
            this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType),
            this.form.categoryType,
            this.apiResult.districtID
          );

          if(vm.component === 'commercial' && vm.currentTabComponent === 'DetailDumpster'){

            vm.updateStages('Details Stage');
            vm.loading = false;

          } else if(vm.component === 'quote') {

            vm.sendHttpRequestQuote('LeadInformation',useAxiosFormStore().getDataToAxios());

          } else {

            vm.loading = false;

          }
        }
        vm.addressVerified = true;
      }).catch(function (error){
        googleApi.gTagSendEvents(
          vm.getLeadTypeFromServiceType(vm.form.serviceType,vm.form.categoryType).toLowerCase(),
          0,
          "Display Services List",
          process.env.VUE_APP_GTAG_LEAD_CATEGORY,
          vm.getLeadTypeFromServiceType(vm.form.serviceType,vm.form.categoryType),
          vm.form.categoryType,
          vm.apiResult.districtID
        );

        if(vm.component === 'commercial' && vm.currentTabComponent === 'DetailDumpster'){

          vm.updateStages('Details Stage');
          vm.dialog = false;
          vm.loading = false;

        } else if(vm.component === 'quote') {

          vm.sendHttpRequestQuote('LeadInformation',useAxiosFormStore().getDataToAxios());

        } else {
          vm.dialog = false;
          vm.loading = false;
        }
        console.log(error);

      })
    },

    isJsonValid(str) {
      try {
          JSON.parse(str);
      } catch (e) {
          return false;
      }
      return true;
    },

    homeOwnerAssociationOrTenant(){
        let vm = this;
        googleApi.gTagSendEvents(
          this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType).toLowerCase(),
          0,
          "Display Services List",
          process.env.VUE_APP_GTAG_LEAD_CATEGORY,
          this.getLeadTypeFromServiceType(this.form.serviceType,this.form.categoryType),
          this.form.categoryType,
          this.apiResult.districtID
        );
        if(vm.component === 'commercial' && vm.currentTabComponent === 'DetailDumpster'){
          vm.updateStages('Details Stage');
        } else if(vm.component === 'quote') {
          vm.sendHttpRequestQuote('LeadInformation',useAxiosFormStore().getDataToAxios());
        }
    },

    //  ********************************************************
    //  REQUEST QUOTE
    //  ********************************************************
    // Toggle the service type to assign to Residential or Business
    warn(toggle,event){
      if(this.form.serviceType != event || this.form.type != event){
      toggle()
      }
    },

    // Fill the SVG with the color depending on the trigger action for Residential
    fillSvgResidential(active,hover){
        if(!active && hover){

          return 'green-svg'

        }
        if(!active && !hover && this.form.serviceType){

          return 'green-svg'

        }
        if(active){

          return 'white-svg'

        }

          return 'green-svg'

    },

    // Fill the SVG with the color depending on the trigger action for Business
    fillSvgBusiness(active,hover){
        if(!active && hover){

          return 'blue-svg'

        }
        if(!active && !hover && this.form.serviceType){

          return 'blue-svg'

        }
        if(active){

          return 'white-svg'

        }
          return 'blue-svg'
    },

    // Fill the background color depending on the trigger action for Residential
    classSvgResidential(active,hover){
        if(!active && hover){

          return "green-hover-svg"

        }
        if(!active && !hover && this.form.serviceType){

          return 'green-default-svg'

        }
        if(active){

          return 'green-active-svg'

        }

          return 'green-default-svg'
    },
    // Fill the background color depending on the trigger action for Business
    classSvgBusiness(active,hover){
        if(!active && hover ){
          return 'blue-hover-svg'
        }
        if(!active && !hover && this.form.serviceType){

          return 'blue-default-svg'

        }
        if(active){

          return 'blue-active-svg'

        }

        return 'blue-default-svg'
    },
    // Assign district by default
    findTheDistrict(district) {
      var vm = this;
      axios
        .post(process.env.VUE_APP_RESTURL + "services/apexrest/ServiceProvidedSearch", {
          callType: "findTheDistrict",
          serviceObject: { districtID: district },
        })
        .then(function (response) {

          if (response.status === 200) {

            let districtID = JSON.parse(response.data);

            if (districtID && districtID.data) {

              vm.form.assignToDistrict = districtID.data;

            }

          }

        })
        .catch(function (error) {
          console.log(error);
        });
    },

    // Remove forms that has no data and return forms that has been filled
    filterExistOnly(objectArray){
      let filteredDumpsters = objectArray.filter((item) => {

        return item.qty || item.frequency.pickupFrequency || item.size.binSize || item.offeredPrice || ''

      })

      return filteredDumpsters.length ? filteredDumpsters : '';

    },

    // Update form and bind to form.servicesWantedForm
    updatedServicesWantedForm(bool){
      // for pricing cards
      if(this.form.servicesWantedJSON){
        this.summaryList = this.form.servicesWantedJSON;
      }
        let json = ''

      if(this.component === 'quote') {

        // Verify which form will be send to salesforce
        if(this.form.menuNavigationId === 'ResiWastePickUp' || this.form.menuNavigationId === 'FoodWaste') {

          json = this.filterExistOnly(this.residentialWantedForm);

        } else if(this.form.menuNavigationId === 'MhoamResidential'){

          json = this.filterExistOnly(this.residentialMhoamWantedForm);

        } else if(this.form.menuNavigationId === 'WasteRecyPickUp' || this.form.menuNavigationId === 'OrganicWaste') {

          const commercialWantedForm = this.filterExistOnly(this.commercialWantedForm);

          if(this.form.servicesWantedWithPricing && !commercialWantedForm){
            json = []
          } else {
            json = commercialWantedForm;
          }

        } else if(this.form.menuNavigationId === 'MhoamView'){

          json = this.filterExistOnly(this.commercialMhoamWantedForm);

        } else if(this.form.menuNavigationId === 'CompIndustWaste'){
          let i = 0;
          this.jsonForm = [];
          while(i < this.form.serviceForm.length) {
            let objectService = {
              title: this.form.categoryType,
              size: this.form.wantedSize,
              qty: this.form.wantedQty,
              frequency: this.form.wantedFrequency,
            };
            objectService.title = this.form.serviceForm[i];
            objectService.icon = this.form.serviceForm[i].trim().toLowerCase();
            this.jsonForm.push(objectService);
            i++;
          }

          json = this.jsonForm;

        } else if(this.form.menuNavigationId === 'DumpsterRental'){

          // Code will fuse individual field that has no form card to the JSON object
          if(this.form.wantedSize || this.form.wantedQty || this.form.wantedFrequency){
            this.jsonForm = [{
              title: this.form.categoryType,
              size: this.form.wantedSize,
              qty: this.form.wantedQty,
              frequency: this.form.wantedFrequency,
            }]
          }else{
            this.jsonForm = '';
          }

          json = this.jsonForm

        }
      }
      else if(this.component === 'commercial' || this.component === 'rolloff') {
        json = [useDumpsterCommercialStore().dumpsterSelected];
      }

      if(!bool){
        this.form.servicesWantedJSON = json;
      }

      return json
    },

    // Convert a Array to String and change delimiter to ";"
    formatSurvey(array){
      if(array.length){

        return array.join(';') + ';';

      }
    },

    // Reset form from v-card when toggled in request quote
    clearCard(toggle, id, form){

      toggle();
      for (let index = 0; index < form.length; index++) {
        if(id === index){

          form[index].qty = 0;
          form[index].size = {};
          form[index].frequency = {};

        }
      }
    },
    // Check and return component name to its initial ( used after resetting all variables to default) )
    getIndexComponent(){
      let index = ''

      if(this.component === 'contact'){

        this.currentTabComponent = "ContactWidgetV3"
        this.form.webSourceForm = "Contact Us From Global Component"

      }

      else if(this.component === 'quote'){

        this.currentTabComponent = "ServiceView"
        this.form.webSourceForm = process.env.VUE_APP_GTAG_LEAD_CATEGORY

      }

      else if(this.component === 'commercial'){

        this.currentTabComponent = "ChooseDumpster"
        this.form.serviceType = "Commercial"
        this.form.webSourceForm = "Commercial Chart Embed - Generic"

      }

      else if(this.component === 'rolloff'){

        this.currentTabComponent = "ChooseRollOff"
        this.form.serviceType = 'Roll Off'
        this.form.webSourceForm = "Roll Off Service Embed - Generic"

      }

      index = this.currentTabComponent;
      return index
    },
    // Generate a unique ID for Facebook Pixel
    generateUniqueFbEventId() {
      // Get current timestamp
      let timestamp = Date.now();
      
      // If this timestamp was used already, increment it
      // This ensures uniqueness by never using the same timestamp twice
      if (timestamp <= this._lastTimestamp) {
        timestamp = this._lastTimestamp + 1;
      }
      
      // Update the last timestamp
      this._lastTimestamp = timestamp;
      
      // Generate the random part exactly as in the original
      const random = Math.random().toString(36).slice(2, 11);
      
      // Return in exactly the original format
      return `fb-${timestamp}-${random}`;
    },


    filterSizesByAPI(apiData, addNotSure) {
      const serviceType = this.getLeadTypeFromServiceType(this.form.serviceType, this.form.categoryType);
      const sizeMapping = {
        'Residential': this.sizesResiWasteRecycling,
        'Commercial': this.sizesWasteRecycling,
        'Construction': this.sizesROWasteRecycling
      }[serviceType];

      const sizes = apiData.data?.RequestQuoteSetting?.Sizes?.[serviceType];
      if (!sizes || !sizeMapping) return false;

      const activeSizes = Object.keys(sizes).filter(key => sizes[key] === true);
      if (!activeSizes.length) return false;

      const sizesName = sizeMapping.filter(size => activeSizes.includes(size.apiName));

      return addNotSure
        ? [{
            binSize: null,
            text: i18n.t('iAmNotSure', 'en'),
            textFr: i18n.t('iAmNotSure', 'fr'),
            displayText: i18n.t('iAmNotSure')
          }, ...sizesName]
        : sizesName;
    },

    // Capitalize each word and lowercase the rest (e.g. "32 GALLON" -> "32 Gallon")
    capitalizeWords(str) {
      return (str || '').toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
    },

    // Map the request-quote lead type to the LOB code expected by the district service API
    getLobFromLeadType() {
      const leadType = this.getLeadTypeFromServiceType(this.form.serviceType, this.form.categoryType);
      return {
        'Residential': 'RESI',
        'Commercial': 'COMM',
        'Construction': 'TEMP'
      }[leadType] || '';
    },

    // Load district-specific service sizes (callType districtServiceSizeByLOB)
    // Falls back to the default sizes (filterSizesByAPI) when the district has no values
    getDistrictServiceSizeByLOB(field) {
      var vm = this;
      const leadType = this.getLeadTypeFromServiceType(this.form.serviceType, this.form.categoryType);
      const staticList = {
        'Residential': this.sizesResiWasteRecycling,
        'Commercial': this.sizesWasteRecycling,
        'Construction': this.sizesROWasteRecycling
      }[leadType];

      if (!staticList) return;

      // Default = current behaviour (the view keeps its own static fallback when this is falsy)
      vm[field] = this.filterSizesByAPI(this.apiResultOriginal, true);

      const districtNumber = (this.apiResult.districtID || '').replace('A', '');
      const lob = this.getLobFromLeadType();
      if (!districtNumber || !lob) return;

      axios
        .post(process.env.VUE_APP_RESTURL + "services/apexrest/ServiceProvidedSearch", {
          callType: "districtServiceSizeByLOB",
          districtServiceObject: { districtNumber: districtNumber, lob: lob },
        })
        .then(function (response) {
          if (response.status === 200) {
            const result = JSON.parse(response.data);
            const apiSizes = (result && result.size) || [];

            if (apiSizes.length) {
              // A real static item used as shape template for unknown district sizes
              const template = staticList.find(item => item.apiName) || staticList[0] || {};

              const sizes = apiSizes.map(s => {
                const code = (s || '').toUpperCase();
                // Known size -> keep the full static object; unknown -> passthrough with the same keys
                const known = staticList.find(size => size.binSize && size.binSize.toUpperCase() === code);
                if (known) return known;

                const passthrough = {};
                Object.keys(template).forEach(key => { passthrough[key] = null; });
                passthrough.text = vm.capitalizeWords(s);
                passthrough.textFr = vm.capitalizeWords(s);
                passthrough.displayText = vm.capitalizeWords(s);
                passthrough.binSize = s;
                return passthrough;
              });

              vm[field] = [{
                binSize: null,
                text: i18n.t('iAmNotSure', 'en'),
                textFr: i18n.t('iAmNotSure', 'fr'),
                displayText: i18n.t('iAmNotSure')
              }, ...sizes];
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    // Load district-specific pickup frequencies for the selected size (callType districtServiceFrequencyBySizeAndLOB)
    // Returns a promise resolving to the frequency list (or "") so each view can track loading per service line.
    getDistrictServiceFrequencyBySizeAndLOB(size) {
      var vm = this;

      const districtNumber = (this.apiResult.districtID || '').replace('A', '');
      const lob = this.getLobFromLeadType();

      // No size selected (e.g. "I am not sure") -> fall back to the static frequencies
      if (!size || !districtNumber || !lob) {
        return Promise.resolve('');
      }

      return axios
        .post(process.env.VUE_APP_RESTURL + "services/apexrest/ServiceProvidedSearch", {
          callType: "districtServiceFrequencyBySizeAndLOB",
          districtServiceObject: { districtNumber: districtNumber, lob: lob, size: size },
        })
        .then(function (response) {
          let loaded = '';

          if (response.status === 200) {
            const result = JSON.parse(response.data);
            const apiFrequencies = (result && result.frequency) || [];

            if (apiFrequencies.length) {
              // A real static item used as shape template for unknown district frequencies
              const template = vm.pickupFrequencies[0] || {};

              // Match each returned code to a static frequency; unknown (e.g. "OC") -> passthrough with the same keys
              loaded = apiFrequencies.map(code => {
                const known = vm.pickupFrequencies.find(freq => freq.pickupFrequency === code);
                if (known) return known;

                const passthrough = {};
                Object.keys(template).forEach(key => { passthrough[key] = null; });
                passthrough.frequency = vm.capitalizeWords(code);
                passthrough.frequencyFr = vm.capitalizeWords(code);
                passthrough.displayFrequency = vm.capitalizeWords(code);
                passthrough.pickupFrequency = code;
                return passthrough;
              });
            }
          }

          return loaded;
        })
        .catch(function (error) {
          console.log(error);
          return '';
        });
    },

    // reset variables to defaults
    resetAll(){
      reset.commercialChart();
      reset.quote();
      reset.user();
      reset.address();
      reset.apiStoreData();
      reset.sizes();
    },
  },
})